<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="isLoadingMap.table === true"
      class="elevation-1"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-center">
            <avatar
              :firstname="item.firstName"
              :lastname="item.lastName"
              :size="35"
              :font="14"
            />
          </td>
          <td>
            {{ `${item.firstName || ''} ${item.lastName || ''}`.trim() }} <br>
            <span class="caption grey--text">{{ item.role }}</span>
          </td>
          <td>
            {{ item.email }}
          </td>
          <td>
            {{ item.phoneNumber }}
          </td>
          <td>
            <v-chip
              small
              outlined
              rounded
              :color="userStatus(item, 'color')"
            >
              {{ userStatus(item, 'label') }}
            </v-chip>
          </td>
          <td class="text-center">
            <v-progress-circular
              v-if="isLoadingMap[item.id] === true"
              :size="20"
              :width="2"
              color="primary"
              indeterminate
            />
            <v-menu
              v-if="isLoadingMap[item.id] !== true"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        left
                        small
                      >
                        edit
                      </v-icon>
                      Edit
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.joined !== true"
                  @click.stop="onSendInvite(item.id)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        left
                        small
                      >
                        send
                      </v-icon>
                      {{ item.invited ? 'Resend Invite' : 'Send Invite' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        left
                        small
                      >
                        not_interested
                      </v-icon>
                      Deactivate
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <user-delete-dialog
                  :id="item.id"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click.stop=""
                    >
                      <v-list-item-content>
                        <v-list-item-title class="error--text">
                          <v-icon
                            left
                            small
                            color="error"
                          >
                            delete
                          </v-icon>
                          Delete
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </user-delete-dialog>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Avatar from "../Avatar"
import UserDeleteDialog from "./UserDeleteDialog"

export default {
  components: { UserDeleteDialog, Avatar },
  computed: {
    ...mapGetters([ 'undeletedUsers' ]),
    items() {
      return this.undeletedUsers
    }
  },
  methods: {
    ...mapActions([ 'fetchTenantUsers', 'inviteTenantUser' ]),
    userStatus(user, key) {
      const map = {
        JOINED: {
          color: 'green',
          label: 'Joined'
        },
        INVITED: {
          color: 'warning',
          label: 'Invited'
        },
        NOT_INVITED: {
          color: 'error',
          label: 'Not invited'
        }
      }

      if (user.joined === true) {
        return map.JOINED[ key ]
      }
      if (user.invited === true) {
        return map.INVITED[ key ]
      }

      return map.NOT_INVITED[ key ]
    },
    setIsLoadingMap(id, value) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [ id ]: !!value
      }
    },
    async onSendInvite(uid) {
      this.setIsLoadingMap(uid, true)
      const payload = { uid }
      await this.inviteTenantUser(payload)
        .then(() => { this.loadTable() })
        .finally(() => { this.setIsLoadingMap(uid, false) })
    },
    async loadTable() {
      this.setIsLoadingMap('table', true)

      const users = await this.fetchTenantUsers()
        .then(res => res.data)
        .finally(() => { this.setIsLoadingMap('table', false) })

      this.users = [ ...users ]
    }
  },
  async mounted() {
    await this.loadTable()
  },
  data() {
    return {
      isLoadingMap: {},
      users: [],
      headers: [
        {
          text: '',
        },
        {
          text: 'Name',
        },
        {
          text: 'Email',
        },
        {
          text: 'Phone',
        },
        {
          text: 'Status'
        },
        {
          text: 'Actions',
          align: 'right'
        }

      ]
    }
  }
}
</script>
